import { render, staticRenderFns } from "./tabReg.vue?vue&type=template&id=22e7e9a9&scoped=true&"
import script from "./tabReg.vue?vue&type=script&lang=js&"
export * from "./tabReg.vue?vue&type=script&lang=js&"
import style0 from "./tabReg.vue?vue&type=style&index=0&id=22e7e9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e7e9a9",
  null
  
)

export default component.exports